<template>
  <div class="bg">
    <div class="img-content">
      <img class="chap" src="../assets/images/chap.png" alt="" />
      <div class="tle">链白茶溯源链</div>
      <div class="item">
        <div>所在链</div>
        <div>链白茶溯源链</div>
      </div>
      <div class="item">
        <!--        链茶溯源链-->
        <div>所在区块</div>
        <div>890566</div>
      </div>
      <div class="item">
        <div>成立时间</div>
        <div>{{ ts | formant }}</div>
      </div>
      <div class="item">
        <div>唯一标识码</div>
        <div>{{ txid }}</div>
      </div>
      <div style="margin: -20px 30px 0; color: #808080; font-size: 12px">
        <div
          style="display: flex; justify-content: space-between; height: 26px"
        >
          <p>上链身份</p>
          <p>{{ list[0].shop_name }}</p>
        </div>
        <!-- <div style="display: flex; justify-content: space-between;">
          <p>上传主体证明</p>
          <p>{{}}</p>
        </div>-->
        <div style="display: flex; justify-content: space-between">
          <p>上链时间</p>
          <p>{{ ts | formant }}</p>
        </div>
        <!-- <div style="display: flex; justify-content: space-between;">
          <p>上传位置</p>
          <p>{{}}</p>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    ts: Number,
    txid: String,
  },
  data() {
    return {
      listDataAll: [],
      list: [],
      dataList: [],
      listInfo: {},
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    this.listDataAll = JSON.parse(window.localStorage.getItem("defalutObj"));
    this.list = this.listDataAll.filter(
      (item) => item.trace_name === "防伪信息"
    );
    console.log(1111, this.list);
    console.log(this.listDataAll);
    this.list.forEach((item) => [(this.dataList = item.msgItems)]);
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  //方法
  methods: {},
};
</script>
<style lang="scss" scoped>
.bg {
  margin-top: 50px;
  width: 686px;
  height: 1110px;
  background: url("~@/assets/images/certificate.png");
  background-size: 686px 1110px;
  background-repeat: no-repeat;
  box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.16);
  border-radius: 8px;
  background-color: #fff;
  .img-content {
    position: relative;
    border: 1px solid #ccc;
    width: 686px;
    height: 1110px;
    .chap {
      position: absolute;
      top: 64%;
      right: 96px;
      width: 200px;
      height: 200px;
    }
    .tle {
      margin: 100px 0 60px;
      font-size: 44px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 56px;
      color: #cc833e;
      text-align: center;
    }
    .item {
      // margin: 0 0 54px 60px;
      margin: 0 60px 54px;
      font-size: 24px;
      font-family: PingFang SC;
      line-height: 24px;
      color: #808080;
      div {
        &:last-child {
          margin-top: 10px;
          font-size: 28px;
          text-align: center;
          font-family: PingFang SC;
          line-height: 40px;
          color: #222222;
          background: #f5f5f5;
          border-radius: 8px;
          padding: 16px 12px;
          word-break: break-all;
        }
      }
    }
    .footer {
      margin-bottom: 16px;
      width: 526px;
      display: flex;
      justify-content: space-between;
      font-size: 10px;
    }
  }
}
</style>
